
import React from "react";
import {Outlet} from "react-router-dom";
// import Navbar from "../Navbar";
import ResponsiveAppBar from "../ResponsiveAppBar";

const Layout = () => {
  return (
    <>
      {/* <Navbar /> */}
      <ResponsiveAppBar />
      <Outlet />
    </>
  );
};

export default Layout;